import {envBackHost} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'

/*********************************************************************
 ** react-query(@tanstack/react-query) 전용 fetcher 모음
 ** 기존 api.ts(콜백형 onSuccess/onError/onLoading)와 분리해서 관리.
 ** 여기 함수들은 순수하게 Promise<데이터>만 반환한다.
 *********************************************************************/

/**
 * 확인이 필요한 수용가 조회 (GET /customer-issues)
 * 응답을 {customerIssues, issueCounts, count} 형태로 반환.
 */
export const fetchCustomerIssueList = async (officeInfo: any, cooperInfo: any, filter: any) => {
  const res = await axiosWithAuth().get(`${envBackHost}/customer-issues`, {
    params: {
      ...filter,
      officeId: officeInfo?.value === 'yit' ? 'all' : officeInfo?.value,
      cooperIdx: cooperInfo?.value,
      // 백엔드는 issueTypes를 쉼표로 구분된 문자열로 받음 (예: "A,B")
      issueTypes: filter?.issueTypes?.length ? filter.issueTypes.join(',') : undefined,
    },
  })
  return {
    customerIssues: res.data.res.customerIssues ?? [],
    issueCounts: res.data.res.issueCounts ?? {},
    count: res.data.count,
  }
}

/*********************************************************************
 ** A/S 관련 순수 API 호출 (confirm/alert 없이 네트워크만 담당)
 ** confirm 다이얼로그·검증·결과 알림은 호출부(mutation 훅)에서 처리.
 *********************************************************************/

/** A/S 등록 원인 코드 조회 (confirm 다이얼로그에 넘길 원본 응답 그대로 반환) */
export const getAsCauseType = async () => {
  return axiosWithAuth().get(`${envBackHost}/worktype/as/codetype/cause`)
}

/** A/S 등록 */
export const postAsRegister = async (payload: {
  asList: any[]
  asId: any
  causeIdx: any
  registerId: any
}) => {
  const res = await axiosWithAuth().post(`${envBackHost}/as`, payload)
  return res.data
}

/** A/S 취소 */
export const putAsCancel = async (payload: {asList: any[]}) => {
  const res = await axiosWithAuth().put(`${envBackHost}/as/delete`, payload)
  return res.data
}

/**
 * 확인이 필요한 수용가 상세 검침 이력 (GET /customer-issue/checkmeters)
 * res 배열을 그대로 반환.
 */
export const fetchCustomerIssueCheckmeters = async (
  officeId: any,
  customerNumber: any,
  filter: any
) => {
  const res = await axiosWithAuth().get(`${envBackHost}/customer-issue/checkmeters`, {
    params: {...filter, officeId, customerNumber},
  })
  return res.data.res ?? []
}

/*********************************************************************
 ** 엑셀 다운로드 전용 fetcher (blob 반환)
 ** 목록/상세 조회와 동일한 파라미터를 그대로 사용한다.
 *********************************************************************/

/**
 * 확인이 필요한 수용가 목록 엑셀 (GET /customer-issues/excel)
 * 목록 조회(fetchCustomerIssueList)와 동일한 파라미터 규칙을 따른다.
 */
export const fetchCustomerIssueListExcel = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any
) => {
  const res = await axiosWithAuth().get(`${envBackHost}/customer-issues/excel`, {
    params: {
      ...filter,
      officeId: officeInfo?.value === 'yit' ? 'all' : officeInfo?.value,
      cooperIdx: cooperInfo?.value,
      issueTypes: filter?.issueTypes?.length ? filter.issueTypes.join(',') : undefined,
    },
    responseType: 'blob',
  })
  return res.data
}

/**
 * 확인이 필요한 수용가 상세 검침 이력 엑셀 (GET /customer-issue/checkmeters/excel)
 * 상세 조회(fetchCustomerIssueCheckmeters)와 동일한 파라미터 규칙을 따른다.
 */
export const fetchCustomerIssueCheckmetersExcel = async (
  officeId: any,
  customerNumber: any,
  filter: any
) => {
  const res = await axiosWithAuth().get(`${envBackHost}/customer-issue/checkmeters/excel`, {
    params: {...filter, officeId, customerNumber},
    responseType: 'blob',
  })
  return res.data
}
